import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  loading: false,
  plan: {},
  error: false,
});

export const { Creators, Types } = createActions({
  createPlanRequested: ['values'],
  createPlanSuccess: ['plan'],
  createPlanError: ['error'],
});

// INFO: Selector Example:
// const getData = state => {
//   const userAge = state.goals.goals.age;
//   const otherInfo = state.goals.goals.age;;

//   return ({
//     age: userAge,
//     money: otherInfo,
//   });
// }

export const Selectors = {
  // Selector will be here...
};

export const Reducer = createReducer(INITIAL_STATE, {
  [Types.CREATE_PLAN_REQUESTED]: state => state.merge({ loading: true }),
  [Types.CREATE_PLAN_SUCCESS]: (state, { plan }) => state.merge({ loading: false, plan, error: false, }),
  [Types.CREATE_PLAN_ERROR]: state => state.merge({ loading: false, error: true, }),
});
